import React, { useState } from 'react';
import { Typography, Alert } from 'antd';
import { ThunderboltOutlined, SunOutlined, LockOutlined } from '@ant-design/icons';
import { useCognitoAuth } from '../contexts/CognitoAuthContext';
import { useApp } from '../contexts/AppContext';
import { canAccessSimuladores } from '../utils/roleUtils';
import SolarPrivadoModal from './SolarPrivadoModal';
import SolarWizardModal from './SolarWizardModal';
import './Simuladores.css';

const { Title, Text } = Typography;

const Simuladores: React.FC = () => {
  const { user } = useCognitoAuth();
  const { currentBusinessArea } = useApp();
  const [solarModalVisible, setSolarModalVisible] = useState(false);
  const [wizardModalVisible, setWizardModalVisible] = useState(false);
  const [selectedProposalType, setSelectedProposalType] = useState<string>('');

  const handleEdpClick = () => {
    window.open('http://edp.b2c.effizency.com', '_blank', 'noopener,noreferrer,width=1200,height=800,scrollbars=yes,resizable=yes');
  };

  const handleSolarClick = () => {
    setSolarModalVisible(true);
  };

  const handleSolarModalClose = () => {
    setSolarModalVisible(false);
  };

  const handleProposalSelect = (proposalType: string) => {
    setSelectedProposalType(proposalType);
    setWizardModalVisible(true);
  };

  const handleWizardModalClose = () => {
    setWizardModalVisible(false);
    setSelectedProposalType('');
  };

  // Check if user has access (double-check for security)
  const hasAccess = user && user.role && user.business_area && 
    canAccessSimuladores(user.role, user.business_area, currentBusinessArea);

  if (!hasAccess) {
    return (
      <div className="simuladores-container">
        <div className="simuladores-content">
          <Alert
            message="Acesso Restrito"
            description="Esta funcionalidade está disponível apenas para utilizadores da área de Energia ou administradores que tenham mudado para o lado da Energia."
            type="warning"
            showIcon
            icon={<LockOutlined />}
            style={{ maxWidth: '600px', margin: '0 auto' }}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="simuladores-container">
        <div className="simuladores-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
            <div className="shape shape-7"></div>
            <div className="shape shape-8"></div>
          </div>
        </div>
        
        <div className="simuladores-content">
          <Title level={1} className="simuladores-title">
            Simuladores de Energia
          </Title>
          <Text className="simuladores-subtitle">
            Escolha o simulador que melhor se adequa às suas necessidades energéticas
          </Text>
          
          <div className="simuladores-divisions">
            <button 
              className="simulador-button edp" 
              onClick={handleEdpClick}
            >
              <ThunderboltOutlined className="simulador-icon" />
              EDP
              <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>
                Simulador de energia elétrica
              </Text>
            </button>
            
            <button 
              className="simulador-button solar" 
              onClick={handleSolarClick}
            >
              <SunOutlined className="simulador-icon" />
              Solar Privado
              <Text style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>
                Simulador de energia solar
              </Text>
            </button>
          </div>
        </div>
      </div>

      <SolarPrivadoModal
        visible={solarModalVisible}
        onClose={handleSolarModalClose}
        onSelectProposal={handleProposalSelect}
      />

      <SolarWizardModal
        visible={wizardModalVisible}
        onClose={handleWizardModalClose}
        proposalType={selectedProposalType}
      />
    </>
  );
};

export default Simuladores; 